import { render, staticRenderFns } from "./moreSet.vue?vue&type=template&id=5f674471"
import script from "./moreSet.vue?vue&type=script&lang=js"
export * from "./moreSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports